import { Features } from "@/src/sb/business-layer/types"
import Briefcase from "@/src/sb/components/icon/Briefcase"
import GlobeV2 from "@/src/sb/components/icon/GlobeV2"
import HamburgerMenu from "@/src/sb/components/icon/HamburgerMenu"
import Sectors from "@/src/sb/components/icon/Sectors"
import Voter from "@/src/sb/components/icon/Voter"
import { ROOT_ITEM_TO_IGNORE_MOBILE } from "@/src/sb/constants"
import {
  SIDEBAR_COUNTRIES_CLASS_NAME,
  SIDEBAR_INDUSTRIES_CLASS_NAME
} from "@/src/sb/constants/featureFlags"

type MobileNavbarV2Props = {
  setNextQueryParam?: boolean
  onClickIntelligence?: (itemsIDToHide: Array<number>) => void
  menuItems: Array<string>
  features?: Features
}

const MENU_ITEM_ICON = [
  null,
  <GlobeV2 key={"countries"} size={28} />,
  <Sectors key={"sectors"} size={28} />,
  <Voter key={"open-data"} size={28} />
]

const MobileNavbarV2 = ({
  onClickIntelligence,
  menuItems,
  features
}: MobileNavbarV2Props) => {
  const tagClassificationNames: Record<string, any> = {
    countries: features?.[SIDEBAR_COUNTRIES_CLASS_NAME],
    industries: features?.[SIDEBAR_INDUSTRIES_CLASS_NAME]
  }

  const menuItemToRender = menuItems.filter(Boolean)

  const mobileMenuItemsIdx = Array.from(Array(menuItemToRender.length)).map(
    (_, menuItemIdx) => menuItemIdx
  )

  const isPEOrOpenData = (item: string) =>
    ROOT_ITEM_TO_IGNORE_MOBILE.includes(item)

  const menuItemProps = {
    className:
      "flex flex-col gap-0.5 capitalize items-center justify-between cursor-pointer dark:text-gray-400 text-xs font-light font-jakarta"
  }

  return (
    <section
      className={
        "flex justify-between dark:bg-black dark:text-stears_white fixed bottom-0 left-0 z-10 w-full p-2.5 md:hidden leading-[18px]"
      }
    >
      <button
        {...menuItemProps}
        onClick={() => {
          const filteredMenuItemsIdx = mobileMenuItemsIdx.slice(1)

          onClickIntelligence?.(filteredMenuItemsIdx)
        }}
      >
        <span className={"inline-block shrink-0 dark:text-white"}>
          <Briefcase size={24} />
        </span>
        Private Capital
      </button>

      {menuItemToRender.map((menuItem, idx) => {
        const item = (
          <>
            <span className={"inline-block shrink-0 dark:text-white"}>
              {MENU_ITEM_ICON[idx]}
            </span>
            {tagClassificationNames?.[menuItem] ?? menuItem}
          </>
        )

        return (
          !isPEOrOpenData(menuItem) && (
            <button
              key={menuItem}
              {...menuItemProps}
              onClick={() =>
                onClickIntelligence?.(
                  // const findItemIndex = menuItem
                  mobileMenuItemsIdx.filter(
                    (menuItemIdx) => idx !== menuItemIdx
                  )
                )
              }
            >
              {item}
            </button>
          )
        )
      })}

      <button
        {...menuItemProps}
        onClick={() => {
          const filteredMenuItemsIdx = mobileMenuItemsIdx.slice(0, -1)

          onClickIntelligence?.(filteredMenuItemsIdx)
        }}
      >
        <span className={"inline-block shrink-0 dark:text-white"}>
          <HamburgerMenu size={28} />
        </span>
        More
      </button>
    </section>
  )
}

export default MobileNavbarV2
